import { useCallback, useEffect, useState } from 'react';
import {
  checkForAppUpdate,
  type UpdateCheckResult,
} from '@/mobile/services/appVersion.service';

export function useAppUpdate(autoCheck = true) {
  const [result, setResult] = useState<UpdateCheckResult | null>(null);
  const [checking, setChecking] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  const check = useCallback(async () => {
    setChecking(true);
    try {
      const next = await checkForAppUpdate();
      setResult(next);
      return next;
    } finally {
      setChecking(false);
    }
  }, []);

  useEffect(() => {
    if (autoCheck) void check();
  }, [autoCheck, check]);

  return {
    result,
    checking,
    dismissed,
    dismiss: () => {
      if (result?.forceUpdate) return;
      setDismissed(true);
    },
    check,
    showDialog: Boolean(result?.updateAvailable && (!dismissed || result?.forceUpdate)),
  };
}
